import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import HomePage from '@/pages/HomePage';
import TrademarkRegistrationPage from '@/pages/TrademarkRegistrationPage';
import CopyrightRegistrationPage from '@/pages/CopyrightRegistrationPage';
import CompanyFormationPage from '@/pages/CompanyFormationPage';
import TrademarkSearchPage from '@/pages/TrademarkSearchPage';
import AmazonBrandRegistryPage from '@/pages/AmazonBrandRegistryPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import TermsPage from '@/pages/TermsPage';
import '@/App.css';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/trademark-registration" element={<TrademarkRegistrationPage />} />
          <Route path="/copyright-registration" element={<CopyrightRegistrationPage />} />
          <Route path="/company-formation" element={<CompanyFormationPage />} />
          <Route path="/trademark-search" element={<TrademarkSearchPage />} />
          <Route path="/amazon-brand-registry" element={<AmazonBrandRegistryPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </>
  );
}

export default App;
